import {
	DownloadOutlined,
	InfoCircleOutlined,
	UploadOutlined,
} from '@ant-design/icons';
import { Alert, Button, Upload } from 'antd';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';
import BVContainerLoader from '../../BVContainerLoader/bv-container-loader';

type BVLimitationsImportProps = {
	fileList: UploadFile[];
	setFileList: (list: UploadFile[]) => void;
	importLimitations: (file: File) => Promise<void>;
	loading: boolean;
	resetImportLimitationsState: () => void;

	// NEW
	exportLimitationsImportTemplate: () => Promise<void>;
	exportLimitationsTemplateLoading: boolean;
};

const BVLimitationsImport = ({
	fileList,
	setFileList,
	importLimitations,
	loading,
	resetImportLimitationsState,
	exportLimitationsImportTemplate,
	exportLimitationsTemplateLoading,
}: BVLimitationsImportProps) => {
	const beforeUpload = (file: RcFile) => {
		if (!file.name.endsWith('.xls') && !file.name.endsWith('.xlsx')) {
			return Upload.LIST_IGNORE;
		}

		resetImportLimitationsState();
		setFileList([
			{
				uid: file.uid,
				name: file.name,
				status: 'done',
				originFileObj: file,
			},
		]);

		return false;
	};

	const upload = async () => {
		const f = fileList[0]?.originFileObj;
		if (!f) return;
		await importLimitations(f as File);
	};

	return (
		<div className="admin-card">
			<label className="admin-label">Import Limitations</label>

			<div
				style={{
					display: 'flex',
					gap: 12,
					alignItems: 'center',
					flexWrap: 'wrap',
				}}
			>
				<Upload
					beforeUpload={beforeUpload}
					fileList={fileList}
					maxCount={1}
					onRemove={() => setFileList([])}
					accept=".xls,.xlsx"
				>
					<Button icon={<UploadOutlined />}>Select file</Button>
				</Upload>

				<Button
					type="primary"
					onClick={upload}
					disabled={fileList.length === 0 || loading}
				>
					Upload
				</Button>

				<Button
					icon={<DownloadOutlined />}
					onClick={exportLimitationsImportTemplate}
					loading={exportLimitationsTemplateLoading}
				>
					Download template
				</Button>

				<BVContainerLoader loading={loading} />
			</div>

			<Alert
				style={{ marginTop: 12 }}
				type="info"
				showIcon
				icon={<InfoCircleOutlined />}
				message="How to compose limitations"
				description={
					<div>
						<p style={{ marginBottom: 8 }}>
							<strong>Responsibility Area</strong>, <strong>Cluster</strong> and{' '}
							<strong>Operating Country</strong> limitations can be combined
							with a <strong>Sales Channel</strong>.
						</p>
						<p style={{ marginBottom: 0 }}>
							To do so, prepend the Sales Channel code before the limitation
							value.
							<br />
							Example: to apply a country limitation <code>IT</code> for sales
							channel <code>DOS</code>, use:
							<br />
							<code>DOS IT</code>
						</p>
					</div>
				}
			/>
		</div>
	);
};

export default BVLimitationsImport;
